<template>

	<div class="btn--product margin-tb-25">

		<button @click.prevent="decrement" id="decrease" :dusk="decreaseNumberDuskName"><i class="icon--sm fas fa-minus"></i></button>

		<input class="amount" type="number" name="amount" readonly v-model="value">

		<button @click.prevent="increment" id="increase" :dusk="increaseNumberDuskName"><i class="icon--sm fas fa-plus"></i></button>

	</div>

</template>

<script>
    export default {
        name: "PlusMinusNumberInput",
		data(){
          	return {
          	    counter:0,
                increaseNumberDuskName:'increase',
                decreaseNumberDuskName:'decrease',
			}
		},
		props:['value', 'min', 'max', 'allowed', 'increase', 'decrease'],
		watch:{
          	value(value){
          	    this.counter = value;
			},
		},
		methods:{
            increment(){
                if(this.allowed !== null && typeof this.allowed === 'function'){
                    if(!this.allowed()){
                        return;
                    }
                }

                if(this.max){
                    if(this.counter >= this.max){
                        this.counter = this.max;
                        return;
                    }
                }

				this.counter += 1;
				this.$emit('input', this.counter);
			},
			decrement(){
                if(this.counter <= this.min) {
                    this.counter = this.min;
                    return;
                }
				this.counter -= 1;
                this.$emit('input', this.counter);
			}
		},
		created(){
            this.counter = this.value;

            if(this.increase){
                this.increaseNumberDuskName = this.increase;
            }

            if(this.decrease){
                this.decreaseNumberDuskName = this.decrease;
            }
		}
    }
</script>

<style scoped>

</style>
